import controller from "./customProductConnectionSettings.controller";

/* customProductConnectionSettings.component.js */

/**
 * @desc component for configuring custom product connection settings.
 * @example <custom-product-connection-settings></custom-product-connection-settings>
 */

const customProductConnectionSettings = {
    bindings: {
        product: '<',
        closeWizard: '<',
        saveStep: '<',
        authenticationTypes: '<',
        paginationTypes: '<'
    },
    controller: controller,
    controllerAs: 'cpcsvm',
    templateUrl: '/App/Components/Connections/CustomProductConnection/Settings/customProductConnectionSettings.tmpl.html'
};

export default customProductConnectionSettings;